import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import schedule from "../../../../../ReferenceTable/schedule-template/schedule/shdedule-form/schedule-page/scheduleSchema.json";
import ServiceRecordPresenter from "./ServiceRecordPresenter";
import CardView from "../../../../../../components/common/CardView";
import FormFactory from "../../../../../../components/FormFactory";
import InputFactory from "../../../../../../components/InputFactory";
import { Button, dialog } from "nq-component";
import { DialogConfirmation } from "../../../../../../components/common/Converter";

export default class RemarksPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ServiceRecordPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      scheduleTemplate: [],
      selectedSchedule: props.object.selectedSchedule || "",
      object: [],
      deletedArray: [],
      objects: [],
      count: 0,
      limit: 20,
      current: 1,
    };
  }

  getCollectionName() {
    return "remarks_page";
  }

  //   async componentDidMount() {
  //     this.presenter.componentDidMount();
  //     const schedules = await findObjectUseCase().execute(
  //       this.getCollectionName(),
  //       {
  //         where: { status: "active" },
  //       }
  //     );
  //     this.setState({
  //       scheduleTemplate: schedules,
  //       // selectedSchedule: this.props.object.selectedSchedule,
  //     });
  //   }

  getCurrent() {
    return this.props.object.id;
  }

  // delete function
  // async handleDeleteData(id) {
  //   const filter = this.props.object.schedule.filter((item) => item.id !== id);

  //   console.log("filterrr", filter);
  //   this.props.schedObj(filter);
  // }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  onChange(field, value) {
    console.log("FIELD: ", field);
    console.log("valud: ", value);
  }

  async handleSubmitRemarks(remarks, id) {
    const object = this.props.object;
    const data = {
      remarks: remarks,
      empID: object.id,
      email: object.email,
    };
    if (id) {
      data.id = id;
    }
    try {
      await upsertUseCase().execute(this.getCollectionName(), data);
      dialog.close();
      this.refetchData();
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  handleDeleteData(id) {
    DialogConfirmation(id, this.getCollectionName(), () => this.refetchData());
  }

  handleAddRemarks(data) {
    let remarks = data?.remarks || "";
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Add Remarks</h4>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleSubmitRemarks(remarks, data.id);
              }}
            >
              <hr />
              <div className="col-lg-12 d-grid gap-2 mb-3">
                <InputFactory
                  type="String"
                  _type="Text"
                  field="remarks"
                  defaultValue={data?.remarks}
                  placeholder="Remarks"
                  onChange={(val) => (remarks = val)}
                  required={true}
                />
              </div>
              <hr />

              <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
                <Button
                  className="btn btn-light fs-sm"
                  type="button"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </Button>
                <Button type="submit">Submit</Button>
              </div>
            </form>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { loading, objects, count, limit, current } = this.state;
    // }
    return (
      <>
        <div className="m-4">
          <div className="row">
            <div className="col-lg-12">
              <CardView>
                <div className="d-flex justify-content-end">
                  <Button type="button" onClick={() => this.handleAddRemarks()}>
                    Add Remarks
                  </Button>
                </div>
              </CardView>
            </div>
          </div>
          <Table
            objectId={this.handleDeleteData.bind(this)}
            objectData={(data) => this.handleAddRemarks(data)}
            refetch={this.refetchData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            actionsList={[
              {
                label: <i className="bi bi-trash" />,
                actionType: "delete",
              },
              {
                label: <i className="bi bi-pencil" />,
                actionType: "object",
              },
            ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "email", "created", "updated", "acl"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
